// Modal.js
import React from 'react';
import '../style/css/modal.css'

const Modal = ({ isOpen, children, onClose,modalClass }) => {
    if (!isOpen) return null;
    return (
        <div className={'modal-overlay'} onClick={onClose}>
            <div className={`modal-content ${modalClass}`} onClick={e => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
};

export default Modal;